import { BasketStatus, } from '@as-react/common-types';
import { BasketActionTypes } from '../../../enums/ActionEnums';
import { filterBasketProducts, updateBasketProductQuantity } from '../../../util/ProductUtil';
export const initialState = {
    basketId: null,
    deliveryInfo: {
        amountUntilFreeDelivery: null,
        amountUntilMinimumOrderValue: null,
        delivery: '',
        deliveryMessages: {
            HOME_DELIVERY: '',
        },
        deliveryUnit: '',
        hasEvoucher: false,
        minimumOrderValue: null,
        requiresDelivery: true,
    },
    popup: {
        collapsed: true,
        basketProductData: null,
        status: undefined,
    },
    ccPopup: {
        collapsed: true,
    },
    validationState: undefined,
    products: [],
    mappedProducts: [],
    promotionProducts: [],
    pricing: {
        priceDelivery: 0,
        priceTotalBasket: 0,
        totalBasketDiscountAmount: 0,
        totalPriceSell: 0,
        totalPriceSellBeforeDiscount: 0,
    },
    status: BasketStatus.LOADING,
    totalQuantity: 0,
    vouchers: [],
    validateRegex: '',
    popupMessages: [],
    popupMessagesEnriched: [],
    paybackVoucherMessages: [],
    hasUnavailableProducts: false,
    orderLinesHaveDifferentDeliveryPromises: false,
    clickAndCollectStoreId: null,
};
export const basketReducer = (state = initialState, action) => {
    switch (action.type) {
        case BasketActionTypes.CC_POPUP_OPEN:
            return Object.assign(Object.assign({}, state), { ccPopup: Object.assign(Object.assign({}, state.ccPopup), { collapsed: false }) });
        case BasketActionTypes.CC_POPUP_CLOSE:
            return Object.assign(Object.assign({}, state), { ccPopup: Object.assign(Object.assign({}, state.ccPopup), { collapsed: true }) });
        case BasketActionTypes.POPUP_OPEN:
            return Object.assign(Object.assign({}, state), { popup: {
                    collapsed: false,
                    basketProductData: action.payload.basketProductData,
                    status: action.payload.status,
                    errorCode: action.payload.errorCode,
                    isBulk: action.payload.isBulk,
                    price: action.payload.price,
                }, validationState: undefined });
        case BasketActionTypes.POPUP_CLOSE:
            return Object.assign(Object.assign({}, state), { popup: Object.assign({}, initialState.popup) });
        case BasketActionTypes.SET:
            return Object.assign(Object.assign({}, state), action.payload);
        case BasketActionTypes.SET_BASIC:
            return Object.assign(Object.assign({}, state), { basketId: action.payload.basketId, totalQuantity: action.payload.totalQuantity });
        case BasketActionTypes.STATUS_UPDATE:
            return Object.assign(Object.assign({}, state), { popup: Object.assign(Object.assign({}, state.popup), { status: action.payload.status, errorCode: action.payload.errorCode }) });
        case BasketActionTypes.ERROR_SET:
            return Object.assign(Object.assign({}, state), { validationState: action.payload });
        case BasketActionTypes.UPDATE_QUANTITY_RESULT: {
            const { product } = action.payload;
            return Object.assign(Object.assign({}, state), { productQuantity: {
                    amountUnableToReserve: product.amountUnableToReserve,
                    availableQuantity: product.availableQuantity,
                    requestedQuantity: product.requestedQuantity,
                } });
        }
        case BasketActionTypes.UPDATE_ITEMS_ERROR_STATE: {
            const { mappedProducts } = state;
            const { product: targetProduct } = action.payload;
            if (!targetProduct) {
                mappedProducts.forEach((mappedProduct) => (mappedProduct.errorState = action.payload.errorState));
            }
            else {
                const mappedProduct = mappedProducts.find(pr => pr.productCode === targetProduct.productCode &&
                    pr.colorId === targetProduct.colorId &&
                    String(pr.sku) === targetProduct.sku);
                if (mappedProduct) {
                    mappedProduct.errorState = action.payload.errorState;
                }
            }
            return Object.assign(Object.assign({}, state), { mappedProducts: [...mappedProducts] });
        }
        case BasketActionTypes.HAS_UNAVAILABLE_PRODUCTS_SET:
            return Object.assign(Object.assign({}, state), { hasUnavailableProducts: action.payload });
        case BasketActionTypes.REMOVE_PRODUCT_AND_UPDATE: {
            if (!action.payload.isOptimistic)
                return state;
            return Object.assign(Object.assign({}, state), { products: filterBasketProducts(state.products, action.payload.product), mappedProducts: filterBasketProducts(state.mappedProducts, action.payload.product) });
        }
        case BasketActionTypes.INCREASE_QUANTITY:
        case BasketActionTypes.DECREASE_QUANTITY:
        case BasketActionTypes.UPDATE_QUANTITY_CUSTOM: {
            if (!action.payload.isOptimistic)
                return state;
            return Object.assign(Object.assign({}, state), { products: updateBasketProductQuantity(state.products, action.payload.product, action.type), mappedProducts: updateBasketProductQuantity(state.mappedProducts, action.payload.product, action.type) });
        }
        default:
            return state;
    }
};
